import _ from 'lodash';
import {
  DetectDuplicatesName,
  DetectDuplicatesNameWarningFunction,
  ProjectorMapResourceTypeWarningFunction
} from "./WarningFunctions";


export const LiftoffMappingGroups = [
  // {
  //   group: 'leave_of_absence',
  //   title: 'Leave of Absence',
  //   mappings: [
  //     {
  //       entity: 'projector_leave_types',
  //       title: 'Leave Types',
  //       warningFunction: DetectDuplicatesNameWarningFunction,
  //       fields: [
  //         {
  //           field: 'Name',
  //           title: 'Name',
  //           type: 'text',
  //           required: true
  //         }
  //       ]
  //     }, {
  //       entity: 'projector_time_off_reasons',
  //       title: 'Time Off Reasons',
  //       warningFunction: DetectDuplicatesNameWarningFunction,
  //       fields: [
  //         {
  //           field: 'Name',
  //           title: 'Name',
  //           type: 'text',
  //           required: true
  //         }
  //       ]
  //     },
  //     {type: 'divider'},
  //     {
  //       entity: 'projector_map_employee_resource_type',
  //       remove_render: e => (e.employees === undefined ? "" : e.employees.Email) +
  //         ' -> ' + (e.resource_type === undefined ? "" : e.resource_type.Name),
  //       title: 'Map Employee to Resource Type',
  //       warningFunction: (set, data, mappingData) => {
  //         let warning = '';
  //         let dupes = _.chain(data).map(d => {
  //           return [d.employees.ID];
  //         }).groupBy().filter(v => v.length > 1).value();
  //         if (dupes.length > 0) {
  //           let employeeIds = _.map(dupes, d => d[0][0]);
  //           let emails = _.chain(data).filter(d => employeeIds.includes(d.employees.ID)).map(d => d.employees.Email).uniq().value();
  //           warning = ` You have the following duplicates: ${emails.join(', ')}`;
  //         }
  //         set(warning.trim());
  //       },
  //       fields: [
  //         {
  //           field: 'employees',
  //           idKey: 'EmployeeId',
  //           entity: 'employees',
  //           title: 'Employee',
  //           type: 'mapping',
  //           render: v => v ? v.Email : '-',
  //           optionLabel: 'Email',
  //           optionValue: 'ID',
  //           required: true
  //         }, {
  //           field: 'resource_type',
  //           idKey: 'ResourceTypeId',
  //           entity: 'projector_resource_types',
  //           title: 'Resource Type',
  //           type: 'mapping',
  //           render: v => v.Name,
  //           optionLabel: 'Name',
  //           optionValue: 'ID',
  //           required: true
  //         },
  //       ]
  //     }, {
  //       entity: 'projector_map_leave_resource_types',
  //       remove_render: e => e.resource_type.Name,
  //       title: 'Map Leave to Resource Type',
  //       warningFunction: (set, data, mappingData) => {
  //         let warning = '';
  //         let dupes = _.chain(data).map(d => {
  //           return [
  //             d.leave_type.ID,
  //             d.time_off_reason.ID,
  //             d.resource_type.ID,
  //             d.leave_resource_type.ID
  //           ];
  //         }).groupBy().filter(v => v.length > 1).value();
  //         if (dupes.length > 0) {
  //           warning = ` You have duplicates.`;
  //         }
  //         set(warning.trim());
  //       },
  //       fields: [
  //         {
  //           field: 'leave_type',
  //           idKey: 'LeaveTypeId',
  //           entity: 'projector_leave_types',
  //           title: 'Leave Type',
  //           type: 'mapping',
  //           render: v => v ? v.Name : '-',
  //           optionLabel: 'Name',
  //           optionValue: 'ID',
  //           required: true
  //         }, {
  //           field: 'time_off_reason',
  //           idKey: 'TimeOffReasonId',
  //           entity: 'projector_time_off_reasons',
  //           title: 'Time Off Reason',
  //           type: 'mapping',
  //           render: v => v ? v.Name : '-',
  //           optionLabel: 'Name',
  //           optionValue: 'ID',
  //           required: true
  //         }, {
  //           field: 'resource_type',
  //           idKey: 'ResourceTypeId',
  //           entity: 'projector_resource_types',
  //           title: 'Resource Type',
  //           type: 'mapping',
  //           render: v => v ? v.Name : '-',
  //           optionLabel: 'Name',
  //           optionValue: 'ID',
  //           required: true
  //         }, {
  //           field: 'leave_resource_type',
  //           dataFrom: 'resource_type',
  //           idKey: 'LeaveResourceTypeId',
  //           entity: 'projector_resource_types',
  //           title: 'Leave Resource Type',
  //           type: 'mapping',
  //           render: v => v ? v.Name : '-',
  //           optionLabel: 'Name',
  //           optionValue: 'ID',
  //           required: true
  //         },
  //         {
  //           field: 'TrackBalance',
  //           title: 'Track Balance',
  //           type: 'checkbox',
  //           render: v => v === true ? 'Yes' : 'No'
  //         },
  //         {
  //           field: 'AdjustBalanceHolidays',
  //           title: 'Adjust Balance Holidays',
  //           type: 'checkbox',
  //           render: v => v === true ? 'Yes' : 'No'
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    group: 'scout',
    title: 'Scout',
    mappings: [
      {
        entity: 'scout_capabilities',
        title: 'Capabilities',
        warningFunction: DetectDuplicatesNameWarningFunction,
        fields: [
          {
            field: 'Name',
            title: 'Name',
            type: 'text',
            required: true
          }, {
            field: 'ScoutName',
            title: 'Scout Name',
            type: 'text',
            required: true
          }
        ]
      },
      {
        entity: 'scout_employment_statuses',
        title: 'Employment Statuses',
        warningFunction: DetectDuplicatesNameWarningFunction,
        fields: [
          {
            field: 'Name',
            title: 'Name',
            type: 'text',
            required: true
          }, {
            field: 'ScoutName',
            title: 'Scout Name',
            type: 'text',
            required: true
          }
        ]
      },
      {
        entity: 'scout_entities',
        title: 'Entities',
        warningFunction: DetectDuplicatesNameWarningFunction,
        fields: [
          {
            field: 'Name',
            title: 'Name',
            type: 'text',
            required: true
          }, {
            field: 'ScoutName',
            title: 'Scout Name',
            type: 'text',
            required: true
          }
        ]
      },
      {
        entity: 'scout_locations',
        title: 'Locations',
        warningFunction: DetectDuplicatesNameWarningFunction,
        fields: [
          {
            field: 'Name',
            title: 'Name',
            type: 'text',
            required: true
          }, {
            field: 'ScoutName',
            title: 'Scout Name',
            type: 'text',
            required: true
          }
        ]
      },

      {
        entity: 'scout_practices',
        title: 'Practices',
        warningFunction: DetectDuplicatesNameWarningFunction,
        fields: [
          {
            field: 'Name',
            title: 'Name',
            type: 'text',
            required: true
          }, {
            field: 'ScoutName',
            title: 'Scout Name',
            type: 'text',
            required: true
          }
        ]
      },
      {
        type: 'divider'
      },
      {
        entity: 'scout_map_employment_status_entity',
        remove_render: e => e.employment_status.Name + ' -> ' + e.entity.Name,
        title: 'Map Employment Status to Entity',
        warningFunction: (set, data, mappingData) => {
          let warning = '';
          let dupes = _.chain(data).map(d => d.employment_status.Name).groupBy().filter(v => v.length > 1).flatten().uniq().value();
          if (dupes.length > 0) {
            warning = ` You have the following duplicates [${_.join(dupes, ', ')}].`;
          }
          set(warning.trim());
        },
        fields: [
          {
            field: 'employment_status',
            idKey: 'EmploymentStatusId',
            entity: 'scout_employment_statuses',
            title: 'Employment Status',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          }, {
            field: 'entity',
            idKey: 'EntityId',
            entity: 'scout_entities',
            title: 'Entity',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          },
        ]
      },
      {
        entity: 'scout_map_ignore_capability',
        remove_render: e => e.practice.Name + ' : ' + e.capability.Name,
        title: 'Map Ignore Capability',
        warningFunction: (set, data, mappingData) => {
          let warning = '';
          let dupes = _.chain(data).map(d => d.practice.Name + ' ' + d.capability.Name).groupBy().filter(v => v.length > 1).flatten().uniq().value();
          if (dupes.length > 0) {
            warning = ` You have the following duplicates [${_.join(dupes, ', ')}].`;
          }
          set(warning.trim());
        },
        fields: [
          {
            field: 'practice',
            idKey: 'PracticeId',
            entity: 'scout_practices',
            title: 'Practice',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          }, {
            field: 'capability',
            idKey: 'CapabilityId',
            entity: 'scout_capabilities',
            title: 'Capability',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          },
        ]
      },
      {
        entity: 'scout_map_location_entity',
        remove_render: e => e.location.Name + ' -> ' + e.entity.Name,
        title: 'Map Location to Entity',
        warningFunction: (set, data, mappingData) => {
          let warning = '';
          let dupes = _.chain(data).map(d => d.location.Name).groupBy().filter(v => v.length > 1).flatten().uniq().value();
          if (dupes.length > 0) {
            warning = ` You have the following duplicates [${_.join(dupes, ', ')}].`;
          }
          set(warning.trim());
        },
        fields: [
          {
            field: 'location',
            idKey: 'LocationId',
            entity: 'scout_locations',
            title: 'Location',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          }, {
            field: 'entity',
            idKey: 'EntityId',
            entity: 'scout_entities',
            title: 'Entity',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          },
        ]
      },
      {
        entity: 'scout_map_practice_capability',
        remove_render: e => e.practice.Name + ' : ' + e.capability.Name,
        title: 'Map Practice and Capability',
        warningFunction: (set, data, mappingData) => {
          let warning = '';
          let dupes = _.chain(data).map(d => d.practice.Name + ' ' + d.capability.Name).groupBy().filter(v => v.length > 1).flatten().uniq().value();
          if (dupes.length > 0) {
            warning = ` You have the following duplicates [${_.join(dupes, ', ')}].`;
          }
          set(warning.trim());
        },
        fields: [
          {
            field: 'practice',
            idKey: 'PracticeId',
            entity: 'scout_practices',
            title: 'Practice',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          }, {
            field: 'capability',
            idKey: 'CapabilityId',
            entity: 'scout_capabilities',
            title: 'Capability',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          },
        ]
      },
      {
        entity: 'scout_map_practice_entity',
        remove_render: e => e.practice.Name + ' -> ' + e.entity.Name,
        title: 'Map Practice to Entity',
        warningFunction: (set, data, mappingData) => {
          let warning = '';
          let dupes = _.chain(data).map(d => d.practice.Name).groupBy().filter(v => v.length > 1).flatten().uniq().value();
          if (dupes.length > 0) {
            warning = ` You have the following duplicates [${_.join(dupes, ', ')}].`;
          }
          set(warning.trim());
        },
        fields: [
          {
            field: 'practice',
            idKey: 'PracticeId',
            entity: 'scout_practices',
            title: 'Practice',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          }, {
            field: 'entity',
            idKey: 'EntityId',
            entity: 'scout_entities',
            title: 'Entity',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          },
        ]
      }
    ]
  },
  {
    group: 'projector',
    title: 'Projector',
    mappings: [
      {
        entity: 'projector_capabilities',
        title: 'Capabilities',
        multipleEntities: true,
        warningFunction: (set, data, mappingData) => {
          let count = 0;
          let warning = '';
          data.forEach(d => {
            if (d.Flags.includes('GDC') && d.Flags.includes('GDC_CORPORATE')) {
              count++;
            }
          });
          if (count === 0) {
            warning = 'Requires one GDC, GDC_CORPORATE record.';
          } else if (count > 1) {
            warning = 'Only one GDC, GDC_CORPORATE record allowed.';
          }
          warning += DetectDuplicatesName(data);
          set(warning.trim());
        },
        fields: [
          {
            field: 'Name',
            title: 'Name',
            type: 'text',
            required: true
          }, {
            field: 'Flags',
            title: 'Flags',
            type: 'multiselect',
            render: v => v.join(', '),
            options: ['CREDERA', 'GDC', 'GDC_CORPORATE'],
            rules: [
              {required: true}, {
                message: 'Incorrect combination',
                validator: (_, value) => {
                  const hasCredera = value.includes('CREDERA');
                  const hasGdc = value.includes('GDC');
                  const hasGdcCorporate = value.includes('GDC_CORPORATE');
                  if ((hasCredera && !hasGdc && !hasGdcCorporate) ||
                    (!hasCredera && hasGdc && !hasGdcCorporate) ||
                    (!hasCredera && hasGdc && hasGdcCorporate) ||
                    value.length === 0 // only show required message
                  ) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject();
                  }
                }
              }
            ]
          }
        ]
      }, {
        entity: 'projector_cost_centers',
        title: 'Cost Centers',
        multipleEntities: true,
        warningFunction: DetectDuplicatesNameWarningFunction,
        fields: [
          {
            field: 'Name',
            title: 'Name',
            type: 'text',
            required: true
          },
        ]
      }, {
        entity: 'projector_cost_center_exceptions',
        multipleEntities: true,
        remove_render: e => e.cost_center.Name,
        warningFunction: (set, data, mappingData) => {
          let warning = '';
          let dupes = _.chain(data).map(d => {
            return [d.practice.ID, d.department.ID, d.Level, d.cost_center.ID];
          }).groupBy().filter(v => v.length > 1).value();
          if (dupes.length > 0) {
            warning = ` You have duplicates.`;
          }
          set(warning.trim());
        },
        title: 'Cost Centers Exceptions',
        fields: [
          {
            field: 'practice',
            idKey: 'PracticeId',
            entity: 'projector_practices',
            title: 'Practice',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          }, {
            field: 'department',
            idKey: 'DepartmentId',
            entity: 'projector_departments',
            title: 'Department',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          }, {
            field: 'Level',
            title: 'Level',
            type: 'number',
            number_max: 7,
            number_min: 0,
            render: v => v ? v : '-',
            required: true
          }, {
            field: 'cost_center',
            idKey: 'CostCenterId',
            entity: 'projector_cost_centers',
            title: 'Cost Center',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          },
        ]
      }, {
        entity: 'projector_departments',
        title: 'Departments',
        multipleEntities: true,
        warningFunction: (set, data, mappingData) => {
          let warning = '';
          if (data && data.length > 0) {
            let groupByInstance = _.groupBy(data, 'PsaInstance');
            for (const [instance, instanceData] of Object.entries(groupByInstance)) {
              let count = 0;
              instanceData.forEach(d => {
                if (d.Flags.includes('CORPORATE')) {
                  count++;
                }
              });
              if (count === 0) {
                warning += `Instance ${instance}: Requires one CORPORATE record.`;
              } else if (count > 1) {
                warning += `Instance ${instance}: Only one CORPORATE record allowed.`;
              }
            }
            warning += DetectDuplicatesName(data);
          }
          set(warning.trim());
        },
        fields: [
          {
            field: 'Name',
            title: 'Name',
            type: 'text',
            required: true
          }, {
            field: 'Flags',
            title: 'Flags',
            type: 'multiselect',
            render: v => v.join(', '),
            options: ['NONE', 'FORCE_LOCATION', 'CORPORATE'],
            rules: [
              {required: true}, {
                message: 'Incorrect combination',
                validator: (a, value) => {
                  const hasForceLocation = value.includes('FORCE_LOCATION');
                  const hasNone = value.includes('NONE');
                  const hasCorporate = value.includes('CORPORATE');
                  if ((hasForceLocation && !hasNone && !hasCorporate) ||
                    (!hasForceLocation && hasNone && !hasCorporate) ||
                    (!hasForceLocation && !hasNone && hasCorporate) ||
                    (hasForceLocation && !hasNone && hasCorporate) ||
                    value.length === 0 // only show required message
                  ) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject();
                  }
                }
              }
            ]
          }
        ]
      }, {
        entity: 'projector_employment_status',
        title: 'Employment Status',
        multipleEntities: true,
        warningFunction: DetectDuplicatesNameWarningFunction,
        fields: [
          {
            field: 'Name',
            title: 'Name',
            type: 'text',
            required: true
          },
        ]
      }, {
        entity: 'level_text',
        remove_render: e => e.Name + ' : ' + e.Level + ' : ' + e.Description + ' : ' + e.Source,
        title: 'Level Text',
        noActionFunction: (e) => {
          return e.Source === 'SYSTEM';
        },
        help: 'Name should have this format: L[#], Description should be a one or more titles delimited by ^.',
        warningFunction: (set, data, mappingData) => {
          let warning = '';
          let dupes = _.chain(data).map(d => d.Name + ',' + d.Source).groupBy().filter(v => v.length > 1).flatten().uniq().value();
          if (dupes.length > 0) {
            warning = ` You have the following duplicates [${_.join(dupes, ', ')}].`;
          }
          set(warning.trim());
        },
        fields: [
          {
            field: 'Name',
            title: 'Name',
            type: 'text',
            width: 150,
            rules: [
              {required: true},
              {
                message: 'Incorrect format',
                validator: (_, value) => {
                  if (value.match(/^L[0-7]$/)) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject();
                  }
                }
              }
            ]
          },
          {
            field: 'Level',
            title: 'Level',
            type: 'number',
            number_max: 7,
            number_min: 0,
            width: 150,
            rules: [
              {required: true},
            ]
          },
          {
            field: 'Description',
            title: 'Description',
            type: 'textarea',
            required: true
          },
          {
            field: 'Source',
            title: 'Source',
            width: 150,
            render: v => v,
            type: 'select',
            options: ['NA', 'INDIA', 'LATAM', 'LEAPPOINT'],
            required: true
          }
        ]
      }, {
        entity: 'projector_locations',
        title: 'Locations',
        multipleEntities: true,
        warningFunction: DetectDuplicatesNameWarningFunction,
        fields: [
          {
            field: 'Name',
            title: 'Name',
            type: 'text',
            required: true
          }, {
            field: 'ProjectorName',
            title: 'Projector Name',
            type: 'text',
            required: true
          }
        ]
      }, {
        entity: 'projector_practices',
        title: 'Practices',
        multipleEntities: true,
        warningFunction: (set, data, mappingData) => {
          let warning = '';
          if (data && data.length > 0) {
            let groupByInstance = _.groupBy(data, 'PsaInstance');
            for (const [instance, instanceData] of Object.entries(groupByInstance)) {
              let count = 0;
              instanceData.forEach(d => {
                if (d.Flags.includes('CREDERA') && d.Flags.includes('PARTNER')) {
                  count++;
                }
              });
              if (count === 0) {
                warning += `Instance ${instance}: Requires one CREDERA, PARTNER record.`;
              } else if (count > 1) {
                warning += `Instance ${instance}: Only one CREDERA, PARTNER record allowed.`;
              }
              warning += DetectDuplicatesName(instanceData);
            }
          }
          set(warning.trim());
        }
        ,
        fields: [
          {
            field: 'Name',
            title: 'Name',
            type: 'text',
            required: true
          }, {
            field: 'Flags',
            title: 'Flags',
            type: 'multiselect',
            render: v => v.join(', '),
            options: ['CREDERA', 'GDC', 'ARETEANS', 'PARTNER'],
            rules: [
              {required: true}, {
                message: 'Incorrect combination',
                validator: (_, value) => {
                  const hasCredera = value.includes('CREDERA');
                  const hasGdc = value.includes('GDC');
                  const hasAreteans = value.includes('ARETEANS');
                  const hasPartner = value.includes('PARTNER');
                  if ((hasCredera && !hasGdc && !hasAreteans && !hasPartner) ||
                    (!hasCredera && hasGdc && !hasAreteans && !hasPartner) ||
                    (!hasCredera && !hasGdc && hasAreteans && !hasPartner) ||
                    (hasCredera && !hasGdc && !hasAreteans && hasPartner) ||
                    value.length === 0 // only show required message
                  ) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject();
                  }
                }
              }
            ]
          }, {
            field: 'Corporate',
            title: 'Corporate',
            type: 'checkbox',
            render: v => v === true ? 'Yes' : 'No'
          },
        ]
      }, {
        entity: 'projector_resource_types',
        title: 'Resource Types',
        multipleEntities: true,
        warningFunction: DetectDuplicatesNameWarningFunction,
        fields: [
          {
            field: 'Name',
            title: 'Name',
            type: 'text',
            required: true
          },
        ]
      }, {
        entity: 'projector_timezones',
        title: 'Timezones',
        multipleEntities: true,
        warningFunction: DetectDuplicatesNameWarningFunction,
        fields: [
          {
            field: 'Name',
            title: 'Name',
            type: 'text',
            required: true
          },
        ]
      }, {
        entity: 'projector_titles',
        title: 'Titles',
        multipleEntities: true,
        warningFunction: (set, data, mappingData) => {
          let countCorporateStaff = 0;
          let countAreteans = 0;
          let warning = '';
          let groupedByInstance = _.groupBy(data, 'PsaInstance');
          let instances = Object.keys(groupedByInstance).length;
          data.forEach(d => {
            if (d.Flags.includes('CORPORATE_STAFF')) {
              countCorporateStaff++;
            } else if (d.Flags.includes('ARETEANS')) {
              countAreteans++;
            }

          });
          if (countCorporateStaff === 0) {
            warning = 'Requires one CORPORATE_STAFF record.';
          } else if (countCorporateStaff < instances) {
            warning = 'Requires one CORPORATE_STAFF record per instance.';
          } else if (countCorporateStaff > instances) {
            warning = 'Only one CORPORATE_STAFF record per instance allowed.';
          }
          if (countAreteans === 0) {
            warning += ' Requires one ARETEANS record.';
          } else if (countAreteans > 1) {
            warning += ' Only one ARETEANS record allowed.';
          }
          warning += DetectDuplicatesName(data);
          set(warning.trim());
        },
        fields: [
          {
            field: 'Name',
            title: 'Name',
            type: 'text',
            required: true
          }, {
            field: 'Flags',
            title: 'Flags',
            type: 'multiselect',
            render: v => v.join(', '),
            options: ['CREDERA', 'GDC', 'ARETEANS', 'CORPORATE', 'DELIVERY', 'CORPORATE_STAFF'],
            rules: [
              {required: true}, {
                message: 'Incorrect combination',
                validator: (_, value) => {
                  const hasCredera = value.includes('CREDERA');
                  const hasGdc = value.includes('GDC');
                  const hasAreteans = value.includes('ARETEANS');
                  const hasCorporate = value.includes('CORPORATE');
                  const hasDelivery = value.includes('DELIVERY');
                  const hasCorporateStaff = value.includes('CORPORATE_STAFF')
                  if ((!hasCredera && !hasGdc && !hasAreteans && !hasCorporate && !hasDelivery && hasCorporateStaff) ||
                    (!hasCredera && !hasGdc && hasAreteans && !hasCorporate && !hasDelivery && !hasCorporateStaff) ||
                    (hasCredera && !hasGdc && !hasAreteans && hasCorporate && !hasDelivery && !hasCorporateStaff) ||
                    (hasCredera && !hasGdc && !hasAreteans && !hasCorporate && hasDelivery && !hasCorporateStaff) ||
                    (!hasCredera && hasGdc && !hasAreteans && hasCorporate && !hasDelivery && !hasCorporateStaff) ||
                    (!hasCredera && hasGdc && !hasAreteans && !hasCorporate && hasDelivery && !hasCorporateStaff) ||
                    (hasCredera && hasGdc && !hasAreteans && !hasCorporate && hasDelivery && !hasCorporateStaff) ||
                    (hasCredera && hasGdc && !hasAreteans && hasCorporate && !hasDelivery && !hasCorporateStaff) ||
                    value.length === 0 // only show required message
                  ) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject();
                  }
                }
              }
            ]
          },
        ]
      }, {
        entity: 'projector_user_types',
        title: 'User Types',
        multipleEntities: true,
        warningFunction: DetectDuplicatesNameWarningFunction,
        fields: [
          {
            field: 'Name',
            title: 'Name',
            type: 'text',
            required: true
          },
        ]
      }, {type: 'divider'}, {
        entity: 'projector_map_cost_center',
        remove_render: e => e.cost_center.Name,
        title: 'Map Cost Centers',
        multipleEntities: true,
        warningFunction: (set, data, mappingData) => {
          let warning = '';
          if (data && data.length > 0) {
            let groupByInstance = _.groupBy(data, 'PsaInstance');
            for (const [instance, instanceData] of Object.entries(groupByInstance)) {
              let dupes = _.chain(instanceData).map(d => {
                return [
                  d.practice.ID,
                  d.capability === undefined ? 0 : d.capability.ID,
                  d.location === undefined ? 0 : d.location.ID,
                  d.department.ID,
                  d.cost_center.ID
                ];
              }).groupBy().filter(v => v.length > 1).value();
              if (dupes.length > 0) {
                warning += ` Instance [${instance}]: You have duplicates.`;
              }
            }
          }
          set(warning.trim());
        },
        fields: [
          {
            field: 'practice',
            idKey: 'PracticeId',
            entity: 'projector_practices',
            title: 'Practice',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          }, {
            field: 'capability',
            idKey: 'CapabilityId',
            entity: 'projector_capabilities',
            title: 'Capability',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID'
          }, {
            field: 'location',
            idKey: 'LocationId',
            entity: 'projector_locations',
            title: 'Location',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID'
          }, {
            field: 'department',
            idKey: 'DepartmentId',
            entity: 'projector_departments',
            title: 'Department',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          }, {
            field: 'cost_center',
            idKey: 'CostCenterId',
            entity: 'projector_cost_centers',
            title: 'Cost Center',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          },
        ]
      }, {
        entity: 'projector_map_practice_department',
        remove_render: e => e.practice.Name +
          (e.employment_status === undefined ? "" : ", " + e.employment_status.Name) +
          (e.capability === undefined ? "" : ", " + e.capability.Name) +
          ' -> ' + e.department.Name,
        title: 'Map Department',
        multipleEntities: true,
        warningFunction: (set, data, mappingData) => {
          let warning = '';
          if (data && data.length > 0) {
            let groupByInstance = _.groupBy(data, 'PsaInstance');
            for (const [instance, instanceData] of Object.entries(groupByInstance)) {
              let dupes = _.chain(instanceData).map(
                d => d.practice.Name + " - " + (d.location === undefined ? "None" : d.location.Name) + " - " +
                  (d.employment_status === undefined ? "None" : d.employment_status.Name) +
                  " - " + (d.capability === undefined ? "None" : d.capability.Name)
              ).groupBy().filter(v => v.length > 1).flatten().uniq().value();
              if (dupes.length > 0) {
                warning += ` Instance [${instance}]: You have the following duplicates [${_.join(dupes, ', ')}].`;
              }
              // we need to check if department mapping that do have Employment Status, has the same
              // practice with nil for Employment Status
              let check = [];
              instanceData.forEach(d => {
                if (d.employment_status !== undefined) {
                  if (_.chain(instanceData)
                    .filter(f => f.practice.ID === d.practice.ID && f.employment_status === undefined)
                    .value().length === 0) {
                    check.push(d.practice.Name)
                  }
                }
              });
              if (check.length > 0) {
                warning += ` Instance [${instance}]: Practice [${_.join(_.uniq(check), ', ')}] should ` +
                  `have a record without Employment Status.`;
              }
              // make sure all practices and departments are covered
              const dataPracticeIds = _.uniq(instanceData.map(d => d.practice.ID));
              const dataDepartmentIds = _.uniq(instanceData.map(d => d.department.ID));
              const missingPractices = mappingData.practice.filter(p => p.PsaInstance === instance &&
                !dataPracticeIds.includes(p.ID));
              const missingDepartments = mappingData.department.filter(d => d.PsaInstance === instance &&
                !dataDepartmentIds.includes(d.ID));
              if (missingPractices.length > 0) {
                warning += ` Instance [${instance}]: Missing practices: ` +
                  `[${missingPractices.map(p => p.Name).join(', ')}].`;
              }
              if (missingDepartments.length > 0) {
                warning += ` Instance [${instance}]: Missing departments: ` +
                  `[${missingDepartments.map(d => d.Name).join(', ')}].`;
              }
            }
          }
          set(warning.trim());
        },
        fields: [
          {
            field: 'practice',
            idKey: 'PracticeId',
            entity: 'projector_practices',
            title: 'Practice',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          }, {
            field: 'location',
            idKey: 'LocationId',
            entity: 'projector_locations',
            title: 'Location',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID'
          }, {
            field: 'employment_status',
            idKey: 'EmploymentStatusId',
            entity: 'projector_employment_status',
            title: 'Employment Status',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID'
          }, {
            field: 'capability',
            idKey: 'CapabilityId',
            entity: 'projector_capabilities',
            title: 'Capability',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID'
          }, {
            field: 'department',
            idKey: 'DepartmentId',
            entity: 'projector_departments',
            title: 'Department',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          },
        ]
      }, {
        entity: 'projector_location_to_timezone',
        remove_render: e => e.location.Name + ' -> ' + e.timezone.Name,
        title: 'Map Location to Timezone',
        multipleEntities: true,
        warningFunction: (set, data, mappingData) => {
          let warning = '';
          if (data && data.length > 0) {
            let groupByInstance = _.groupBy(data, 'PsaInstance');
            for (const [instance, instanceData] of Object.entries(groupByInstance)) {
              let dupes = _.chain(instanceData).map(d => d.location.Name).groupBy()
                .filter(v => v.length > 1).flatten().uniq().value();
              if (dupes.length > 0) {
                warning += ` Instance [${instance}]: You have the following duplicates [${_.join(dupes, ', ')}].`;
              }
            }
          }
          set(warning.trim());
        },
        fields: [
          {
            field: 'location',
            idKey: 'LocationId',
            entity: 'projector_locations',
            title: 'Location',
            type: 'mapping',
            render: v => v.Name,
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          }, {
            field: 'timezone',
            idKey: 'TimeZoneId',
            entity: 'projector_timezones',
            title: 'Timezone',
            type: 'mapping',
            render: v => v.Name,
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          },
        ]
      }, {
        entity: 'projector_map_resource_type',
        remove_render: e => e.resource_type.Name,
        warningFunction: ProjectorMapResourceTypeWarningFunction,
        title: 'Map Resource Type',
        multipleEntities: true,
        fields: [
          {
            field: 'employment_status',
            idKey: 'EmploymentStatusId',
            entity: 'projector_employment_status',
            title: 'Employment Status',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          }, {
            field: 'LocationIdList',
            idKey: 'LocationIdList',
            entity: 'projector_locations',
            title: 'Location(s)',
            type: 'mapping',
            multi: true,
            render: r => r ? r.map(v => v.Name).join(', ') : '-',
            optionLabel: 'Name',
            optionValue: 'ID'
          }, {
            field: 'PracticeIdList',
            idKey: 'PracticeIdList',
            entity: 'projector_practices',
            title: 'Practice(s)',
            type: 'mapping',
            multi: true,
            render: r => r ? r.map(v => v.Name).join(', ') : '-',
            optionLabel: 'Name',
            optionValue: 'ID'
          }, {
            field: 'Gdc',
            title: 'GDC',
            type: 'checkbox',
            render: v => v === true ? 'Yes' : 'No'
          }, {
            field: 'TypeFlag',
            title: 'Flags',
            type: 'select',
            render: v => v,
            options: ['N/A', 'DELIVERY', 'CORPORATE'],
            required: true
          }, {
            field: 'resource_type',
            idKey: 'ResourceTypeId',
            entity: 'projector_resource_types',
            title: 'Resource Type',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          },
        ]
      }, {
        entity: 'projector_title_in_practice',
        remove_render: e => e.title.Name + ' -> ' + e.practice.Name,
        warningFunction: (set, data, mappingData) => {
          let warning = '';
          if (data && data.length > 0) {
            let groupByInstance = _.groupBy(data, 'PsaInstance');
            for (const [instance, instanceData] of Object.entries(groupByInstance)) {
              let dupes = _.chain(instanceData).map(d => d.title.Name + ' - ' + d.practice.Name)
                .groupBy().filter(v => v.length > 1).flatten().uniq().value();
              if (dupes.length > 0) {
                warning += ` Instance [${instance}]: You have the following duplicates [${_.join(dupes, ', ')}].`;
              }
            }
          }
          set(warning.trim());
        },
        title: 'Map Title to Practice',
        multipleEntities: true,
        fields: [
          {
            field: 'title',
            idKey: 'TitleId',
            entity: 'projector_titles',
            title: 'Title',
            type: 'mapping',
            render: v => v.Name,
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          }, {
            field: 'practice',
            idKey: 'PracticeId',
            entity: 'projector_practices',
            title: 'Practice',
            type: 'mapping',
            render: v => v.Name,
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          },
        ]
      }, {
        entity: 'projector_map_user_type',
        remove_render: e => e.user_type.Name,
        warningFunction: (set, data, mappingData) => {
          let warning = '';
          if (data && data.length > 0) {
            let groupByInstance = _.groupBy(data, 'PsaInstance');
            for (const [instance, instanceData] of Object.entries(groupByInstance)) {
              let count = 0;
              instanceData.forEach(d => {
                if (d.practice === undefined && d.employment_status === undefined) {
                  count++;
                }
              });
              if (count > 0) {
                warning += ` Instance [${instance}]: Records where both Practice and Employment Status are empty are not allowed.`;
              }
              let dupes = _.chain(instanceData).map(d => {
                return [
                  d.practice === undefined ? 0 : d.practice.ID,
                  d.employment_status === undefined ? 0 : d.employment_status.ID,
                  d.user_type.ID
                ];
              }).groupBy().filter(v => v.length > 1).value();
              if (dupes.length > 0) {
                warning += ` Instance [${instance}]: You have duplicates.`;
              }
            }
          }
          set(warning.trim());
        },
        title: 'Map User Type',
        multipleEntities: true,
        fields: [
          {
            field: 'practice',
            idKey: 'PracticeId',
            entity: 'projector_practices',
            title: 'Practice',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID'
          }, {
            field: 'employment_status',
            idKey: 'EmploymentStatusId',
            entity: 'projector_employment_status',
            title: 'Employment Status',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID'
          }, {
            field: 'user_type',
            idKey: 'UserTypeId',
            entity: 'projector_user_types',
            title: 'User Type',
            type: 'mapping',
            render: v => v ? v.Name : '-',
            optionLabel: 'Name',
            optionValue: 'ID',
            required: true
          },
        ]
      }
    ]
  }
];